import React from 'react';
import PropTypes from 'prop-types';
import Loading from '../components/loading';
import { Permissions } from './models';
import { fetcher } from '@weezevent/weezjs-core';

const PermissionsContext = React.createContext(null);

export const usePermissions = () => {
    return React.useContext(PermissionsContext);
};

export const PermissionsLayer = ({ children }) => {
    const [currentPermissions, setCurrentPermissions] = React.useState(null);

    // Get permissions
    React.useEffect(() => {
        Permissions.load(fetcher).then(permissions => setCurrentPermissions(permissions));
    }, []);

    if (!currentPermissions) {
        return <Loading />;
    }

    return <PermissionsContext.Provider value={currentPermissions}>{children}</PermissionsContext.Provider>;
};

// Lolilol
PermissionsLayer.propTypes = {
    children: PropTypes.node // Amazing
};
